export default function PhilosophySection() {
    return (
        <section id="philosophy" className="py-24 border-b border-subtle bg-[#e9edf1] relative overflow-hidden" data-testid="philosophy-section">
            <div className="absolute inset-0 tb-grid opacity-60 pointer-events-none" />
            <div className="relative max-w-4xl mx-auto px-4 text-center">
                <span className="font-mono text-xs text-cyan-600 tracking-widest uppercase mb-4 block">
                    // Engineering Tenet
                </span>
                <h2 className="font-display text-4xl sm:text-6xl lg:text-7xl font-black text-slate-900 tracking-tight uppercase mb-8 glow-cyan">
                    Maximum Viable Play
                </h2>
                <div className="space-y-4 text-lg sm:text-2xl font-light text-slate-600 max-w-2xl mx-auto leading-snug">
                    <p>Build the thing.</p>
                    <p>See what happens.</p>
                    <p>Learn something.</p>
                    <p className="text-cyan-700 font-normal">Make the next thing slightly less stupid.</p>
                </div>
                <p className="mt-10 max-w-2xl mx-auto text-slate-500 text-sm sm:text-base leading-relaxed">
                    TIMBOTIC exists because the distance between &ldquo;I wonder if...&rdquo; and &ldquo;well,
                    apparently that works&rdquo; has become dangerously short.
                </p>
                <div className="mt-12 p-6 rounded-lg bg-white border border-subtle text-left font-mono text-xs text-slate-500 max-w-xl mx-auto space-y-2">
                    <div className="text-cyan-600 font-bold">MVP FORMULA SPECIFICATION:</div>
                    <div>MVP ≠ MINIMUM VIABLE PRODUCT</div>
                    <div className="text-slate-900 font-semibold">MVP = MAXIMUM VIABLE PLAY</div>
                    <div className="pt-3 text-slate-500 border-t border-slate-200 mt-3">
                        OPTIMISE FOR:
                        <div className="mt-2 grid grid-cols-1 sm:grid-cols-3 gap-2 text-slate-600">
                            <span className="px-2 py-1 rounded bg-slate-100 border border-slate-200 text-center">CURIOSITY</span>
                            <span className="px-2 py-1 rounded bg-slate-100 border border-slate-200 text-center">EXPERIMENTATION</span>
                            <span className="px-2 py-1 rounded bg-slate-100 border border-slate-200 text-center">ACTUALLY BUILDING THE THING</span>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
